"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ChecklistOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<rect x="17" y="10" width="6" height="2" rx="1"/><path d="M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z"/><path d="M14.73,7.78a.9.9,0,0,0-1.3,0l-2.21,2.36-.65-.69a.88.88,0,0,0-1.3,0,1,1,0,0,0,0,1.38l1.3,1.38a.87.87,0,0,0,1.3,0l2.86-3A1,1,0,0,0,14.73,7.78Z"/><path d="M14.73,14.78a.9.9,0,0,0-1.3,0l-2.21,2.36-.65-.69a.88.88,0,0,0-1.3,0,1,1,0,0,0,0,1.38l1.3,1.38a.87.87,0,0,0,1.3,0l2.86-3A1,1,0,0,0,14.73,14.78Z"/><rect x="17" y="17" width="6" height="2" rx="1"/><rect x="17" y="23" width="6" height="2" rx="1"/><rect x="10" y="23" width="4" height="2" rx="1"/>';
var ChecklistOutlineSVG = function ChecklistOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ChecklistOutlineSVG = ChecklistOutlineSVG;
ChecklistOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ChecklistOutlineSVG);
exports.default = _default;